import { Box } from "@material-ui/core"
import React from "react"
import { Route, Switch, useRouteMatch } from "react-router-dom"
import ListPage from "./page/ListPage"
import DetailPage from "./page/DetailPage"

ProductFeature.propTypes = {}

function ProductFeature(props) {
  const match = useRouteMatch()
  return (
    <Box pt={4}>
      <Switch>
        <Route path={match.url} exact component={ListPage}></Route>
        <Route path={`${match.url}/:productId`} component={DetailPage}></Route>
      </Switch>
    </Box>
  )
}

export default ProductFeature
